/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Swal from 'sweetalert2';
import consultaApi from '../../../services/consultaApi';
import FormGrupoImpostoItem from '../form-grupo-imposto-item/index';
import ListagemImpostos from '../listagem-grupo-imposto-item';
import BuscaForm from '../../gww-lib/busca-no-form/index';
import Grid from '@material-ui/core/Grid';
import CampoTextoAjuda from '../../gww-lib/campo-texto-ajuda';

const useStyles = makeStyles(theme => ({
    controlaTitulo: {
        paddingTop: 30,
        paddingBottom: 12,
        fontSize: "2em",
    },
    corDoFundo: {
        backgroundColor: "#f1f1f1",
        paddingBottom: 30,
    },
    containerPrimeiroAcesso: {
        padding: '0px 0px 30px 0px'
    },
    controlaCard: {
        textAlign: "center",
        padding: theme.spacing(1),
    },
    botaoRodape: {
        padding: theme.spacing(1),
    }

}))

function FormGrupoImposto(props, ref) {

    const { grupoImposto, primeiroAcesso } = props;

    const classes = useStyles();

    const [codigoGrupoImposto] = useState(grupoImposto.CCDTAXGRUPO ? grupoImposto.CCDTAXGRUPO : 0);

    const [descricao, setDescricao] = useState(grupoImposto.CDSTAXGRUPO ? grupoImposto.CDSTAXGRUPO : '');
    const [descricaoErro, setDescricaoErro] = useState(false);
    const [descricaoErroTexto, setDescricaoErroTexto] = useState();

    const [stIcms, setStIcms] = useState(grupoImposto.CCDSITICMS ? grupoImposto.CCDSITICMS : '');
    const [descricaoStIcms, setDescricaoStIcms] = useState(grupoImposto.CDSSITICMS ? grupoImposto.CDSSITICMS : '')
    const [stIcmsErro, setStIcmsErro] = useState(false);
    const [stIcmsErroTexto, setStIcmsErroTexto] = useState();

    const [stIpi, setStIpi] = useState(grupoImposto.CCDSITIPI ? grupoImposto.CCDSITIPI : '');
    const [descricaoStIpi, setDescricaoStIpi] = useState(grupoImposto.CDSSITIPI ? grupoImposto.CDSSITIPI : '');
    const [stIpiErro, setStIpiErro] = useState(false);
    const [stIpiErroTexto, setStIpiErroTexto] = useState();

    const [stPis, setStPis] = useState(grupoImposto.CCDSITPIS ? grupoImposto.CCDSITPIS : '');
    const [descricaoStPis, setDescricaoStPis] = useState(grupoImposto.CDSSITPIS ? grupoImposto.CDSSITPIS : '');
    const [stPisErro, setStPisErro] = useState(false);
    const [stPisErroTexto, setStPisErroTexto] = useState();

    const [stCofins, setStCofins] = useState(grupoImposto.CCDSITCOFINS ? grupoImposto.CCDSITCOFINS : '');
    const [descricaoStCofins, setDescricaoStCofins] = useState(grupoImposto.CDSSITCOFINS ? grupoImposto.CDSSITCOFINS : '');
    const [stCofinsErro, setStCofinsErro] = useState(false);
    const [stCofinsErroTexto, setStCofinsErroTexto] = useState();

    const [enquadramentoIpi, setEnquadramentoIpi] = useState(grupoImposto.CCDENQIPI ? grupoImposto.CCDENQIPI : '');
    const [descricaoEnquadramentoIpi, setDescricaoEnquadramentoIpi] = useState(grupoImposto.CDSENQIPI ? grupoImposto.CDSENQIPI : '');
    const [enquadramentoIpiErro, setEnquadramentoIpiErro] = useState(false);
    const [enquadramentoIpiErroTexto, setEnquadramentoIpiErroTexto] = useState();

    const [impostos, setImpostos] = useState([]);

    const history = useHistory();

    function vaiListagem() {
        history.push('/grupo-imposto');
    }

    useEffect(() => {
        async function carregarItem() {
            let itens = [];

            let dadosEnvio = {
                PROCNAME: 'WEBSITE_LISTAGEM_IMP_GRUPOI',
                PCCDTAXGRUPO: codigoGrupoImposto
            };

            const resposta = await consultaApi(dadosEnvio);

            if (resposta.data.CODIGO_ERRO == 0 && resposta.data.DATASET) {
                resposta.data.DATASET.map((item) => {
                    return itens.push({
                        codigoItem: item.CCDTAXSEQ,
                        codigoImposto: item.CCDTAX,
                        descricaoImposto: item.CDSTAX,
                        modalidadeBaseCalculo: item.NMODBASECALCULO,
                        base: item.NTXBASE,
                        aliquota: item.NTXALIQUOTA,
                        acrescimo: item.NTXACRE,
                        reducao: item.NTXREDU,
                        operacaoPropria: item.NTXOPPROPRIA,
                        diferimento: item.NTXDIFERIDO,
                        valorPauta: item.NVLPAUTA
                    });
                });
            }

            setImpostos(itens);

        }

        carregarItem()
    }, []);

    useImperativeHandle(ref, () => ({
        async salvarGrupoImposto() {
            let retornoSalvar = await salvar();
            return retornoSalvar;
        }
    }));

    async function salvarGrupoImposto() {
        let dadosEnvio = {
            PROCNAME: "WEBSITE_TIMPOSTO_GRUPO_ADD",
            PCCDTAXGRUPO: codigoGrupoImposto,
            PCDSTAXGRUPO: descricao.toUpperCase(),
            PCCDSITICMS: stIcms,
            PCCDSITIPI: stIpi,
            PCCDSITPIS: stPis,
            PCCDSITCOFINS: stCofins,
            PCCDENQIPI: enquadramentoIpi
        };

        const resposta = await consultaApi(dadosEnvio);
        return resposta;
    }

    async function salvarItensGrupoImposto(CCDTAXGRUPO) {
        await Promise.all(impostos.map((imposto, index) => {
            return new Promise(async (resolve, reject) => {
                try {
                    let dadosEnvioItem = {
                        PROCNAME: "WEBSITE_TIMPOSTO_GRUPOI_ADD",
                        PCCDTAXSEQ: imposto.codigoItem,
                        PCCDTAX: imposto.codigoImposto,
                        PCCDTAXGRUPO: CCDTAXGRUPO,
                        PNMODBASECALCULO: imposto.modalidadeBaseCalculo,
                        PNTXOPPROPRIA: imposto.operacaoPropria,
                        PNVLPAUTA: imposto.valorPauta,
                        PNTXACRE: imposto.acrescimo,
                        PNTXDIFERIDO: imposto.diferimento,
                        PNTXREDU: imposto.reducao,
                        PNTXALIQUOTA: imposto.aliquota,
                        PNTXBASE: imposto.base
                    };

                    const respostaImposto = await consultaApi(dadosEnvioItem);
                    resolve(respostaImposto);
                } catch (error) {
                    reject(error)
                }
            })

        })).catch(result => {

            return { error: result };
        }).then(result => {
            return result;
        });
    }

    async function salvar(e) {
        if (e) {
            e.preventDefault();
        }

        if (validaCampos()) {

            let resposta = await salvarGrupoImposto();
            if (resposta.data.CODIGO_ERRO == 0) {
                await salvarItensGrupoImposto(resposta.data.PCCDTAXGRUPO);
                if (primeiroAcesso) {
                    return true;
                } else {
                    Swal.fire({
                        type: 'success',
                        html: resposta.data.MENSAGEM_RESPOSTA,
                    });
                    vaiListagem();
                }
            }

        }

    }

    function cancelar() {
        Swal.fire({
            type: 'question',
            title: 'Cancelar ?',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            showLoaderOnConfirm: true,
            preConfirm: (result) => {
                if (result) {
                    vaiListagem()
                }
            },
        });
    }

    function validaCampos() {
        let camposErrados = [];

        if (descricao === '') {
            setDescricaoErro(true);
            setDescricaoErroTexto('Campo Obrigatorio. Por favor preencha a descrição.');
            camposErrados.push("Descrição");
        } else {
            setDescricaoErro(false);
        }

        if (stIcms === '') {
            setStIcmsErro(true);
            setStIcmsErroTexto(`Campo obrigatorio, Por favor preencha`)
            camposErrados.push("St ICMS")
        } else {
            if (descricaoStIcms === '') {
                setStIcmsErro(true);
                setStIcmsErroTexto('Informe uma St de Icms valida, use a pesquisa.')
                camposErrados.push("St ICMS")
            } else {
                setStIcmsErro(false);
            }
        }

        if (stIpi === '') {
            setStIpiErro(true);
            setStIpiErroTexto(`Campo obrigatorio, Por favor preencha`)
            camposErrados.push("St IPI")
        } else {
            if (descricaoStIpi === '') {
                setStIpiErro(true);
                setStIpiErroTexto('Informe uma St de Ipi valida, use a pesquisa.')
                camposErrados.push("St Ipi")
            } else {
                setStIpiErro(false);
            }
        }

        if (stPis === '') {
            setStPisErro(true);
            setStPisErroTexto(`Campo obrigatorio, Por favor preencha`)
            camposErrados.push("St PIS")
        } else {
            if (descricaoStPis === '') {
                setStPisErro(true);
                setStPisErroTexto('Informe uma St de Pis valida, use a pesquisa.')
                camposErrados.push("St PIS")
            } else {
                setStPisErro(false);
            }
        }

        if (stCofins === '') {
            setStCofinsErro(true);
            setStCofinsErroTexto(`Campo obrigatorio, Por favor preencha`)
            camposErrados.push("St Cofins")
        } else {
            if (descricaoStCofins === '') {
                setStCofinsErro(true);
                setStCofinsErroTexto('Informe uma St de Cofins valida, use a pesquisa.')
                camposErrados.push("St Cofins")
            } else {
                setStCofinsErro(false);
            }
        }

        if (enquadramentoIpi === '') {
            setEnquadramentoIpiErro(true);
            setEnquadramentoIpiErroTexto(`Campo obrigatorio, Por favor preencha`)
            camposErrados.push("Equandramento Ipi")
        } else {
            if (descricaoEnquadramentoIpi === '') {
                setEnquadramentoIpiErro(true);
                setEnquadramentoIpiErroTexto('Informe uma Código de enquadramento valido, use a pesquisa.')
                camposErrados.push("Enquadramento Ipi")
            } else {
                setEnquadramentoIpiErro(false);
            }
        }

        if (camposErrados.length === 0) {
            return true;
        } else {
            Swal.fire({
                type: 'error',
                title: 'Campos Inválidos',
                html: `<lu>` +
                    camposErrados.map(campoErrado => (
                        `<li>${campoErrado}</li>`
                    )) +
                    `</lu>`
            })

        }

    };

    function adicionarImpostos(item, indexImposto = -1) {
        if (indexImposto < 0) {
            setImpostos(impostos => [...impostos, item]);
        } else {
            let impostosTemp = impostos;
            impostosTemp[indexImposto] = item;
            setImpostos(impostosTemp => [...impostosTemp]);
        }

    }

    function removerImposto(indexImposto) {
        // eslint-disable-next-line no-unused-vars
        let impostosTemp = impostos.splice(indexImposto, 1);
        setImpostos(impostosTemp => [...impostosTemp]);
    }

    return (
        <Container className={primeiroAcesso ? classes.containerPrimeiroAcesso : classes.corDoFundo} >
            {primeiroAcesso ? '' : <Typography
                variant="h1"
                component="h1"
                gutterBottom
                align="center"
                color="primary"
                className={classes.controlaTitulo}
            >
                Cadastro Grupo de Imposto
            </Typography>}


            <Paper className={classes.controlaCard}>
                <form>
                    <Grid container>

                        <CampoTextoAjuda
                            label="Descrição"
                            error={descricaoErro}
                            helperText={descricaoErroTexto}
                            value={descricao}
                            onChange={e => setDescricao(e.target.value)}
                            tituloAjuda="Descrição"
                            textoAjuda="informe uma descrição para o grupo de imposto."
                            saibaMais={{
                                categoria: 'grupo-imposto',
                                campo: 'descricao'
                            }}
                        />

                        <BuscaForm
                            codigo={stIcms}
                            tabela="ST_ICMS"
                            label="CST/CSOSN Icms"
                            consultaInstantanea
                            setCodigoPai={(stIcm) => setStIcms(stIcm)}
                            setDescricao={setDescricaoStIcms}
                            descricao={descricaoStIcms}
                            procedureConsulta="WEBSITE_LISTAGEM_STICMS"
                            erroTexto={stIcmsErroTexto}
                            erro={stIcmsErro}
                            ajuda={{
                                obrigatorio: true,
                                tituloAjuda: 'CSOSN/CST ICMS',
                                textoAjuda: 'Se sua empresa estiver enquadrada no Simples Nacional Informar o CSOSN (Código de Situação da Operação do Simples Nacional) para o imposto ICMS. Se for do regime normal informar o CST (Código Situação Tributária)para o imposto ICMS. Esta informação deve ser consultada com o contador ou responsável fiscal da empresa.',
                                saibaMais: {
                                    categoria: 'grupo-imposto',
                                    campo: 'cst-icms'
                                }
                            }}
                        />

                        <BuscaForm
                            codigo={stIpi}
                            tabela="ST_IPI"
                            label="CST Ipi"
                            consultaInstantanea
                            setCodigoPai={(stIpi) => setStIpi(stIpi)}
                            setDescricao={setDescricaoStIpi}
                            descricao={descricaoStIpi}
                            procedureConsulta="WEBSITE_LISTAGEM_STIPI"
                            erroTexto={stIpiErroTexto}
                            erro={stIpiErro}
                            ajuda={{
                                obrigatorio: true,
                                tituloAjuda: 'CST IPI',
                                textoAjuda: 'Informar o CST (Código de Situação Tributária) para o imposto IPI. Esta informação deve ser consultada com o contador ou responsável fiscal da empresa.',
                                saibaMais: {
                                    categoria: 'grupo-imposto',
                                    campo: 'cst-ipi'
                                }
                            }}
                        />

                        <BuscaForm
                            codigo={stPis}
                            tabela="ST_PIS"
                            label="CST Pis"
                            consultaInstantanea
                            setCodigoPai={(stPis) => setStPis(stPis)}
                            setDescricao={setDescricaoStPis}
                            descricao={descricaoStPis}
                            procedureConsulta="WEBSITE_LISTAGEM_STPIS"
                            erroTexto={stPisErroTexto}
                            erro={stPisErro}
                            ajuda={{
                                obrigatorio: true,
                                tituloAjuda: 'CST PIS',
                                textoAjuda: 'Informar o CST (Código de Situação Tributária) para o imposto PIS. Esta informação deve ser consultada com o contador ou responsável fiscal da empresa.',
                                saibaMais: {
                                    categoria: 'grupo-imposto',
                                    campo: 'cst-pis'
                                }
                            }}
                        />

                        <BuscaForm
                            codigo={stCofins}
                            tabela="ST_COFINS"
                            label="CST Cofins"
                            consultaInstantanea
                            setCodigoPai={(stCofins) => setStCofins(stCofins)}
                            setDescricao={setDescricaoStCofins}
                            descricao={descricaoStCofins}
                            procedureConsulta="WEBSITE_LISTAGEM_STCOFINS"
                            erroTexto={stCofinsErroTexto}
                            erro={stCofinsErro}
                            ajuda={{
                                obrigatorio: true,
                                tituloAjuda: 'CST COFINS',
                                textoAjuda: 'Informar o CST (Código de Situação Tributária) para o imposto COFINS. Esta informação deve ser consultada com o contador ou responsável fiscal da empresa.',
                                saibaMais: {
                                    categoria: 'grupo-imposto',
                                    campo: 'cst-cofins'
                                }
                            }}
                        />

                        <BuscaForm
                            codigo={enquadramentoIpi}
                            tabela="ENQUADRAMENTO_IPI"
                            label="Enquadramento Ipi"
                            consultaInstantanea
                            setCodigoPai={(enquadramentoIpi) => setEnquadramentoIpi(enquadramentoIpi)}
                            setDescricao={setDescricaoEnquadramentoIpi}
                            descricao={descricaoEnquadramentoIpi}
                            procedureConsulta="WEBSITE_LISTAGEM_ENQIPI"
                            erroTexto={enquadramentoIpiErroTexto}
                            erro={enquadramentoIpiErro}
                            ajuda={{
                                obrigatorio: true,
                                tituloAjuda: 'Enquadramento IPI',
                                textoAjuda: 'Informar um código válido de enquadramento de IPI. Esta informação deve ser consultada com o contador ou responsável fiscal da empresa.',
                                saibaMais: {
                                    categoria: 'grupo-imposto',
                                    campo: 'enquadramento-ipi'
                                }
                            }}
                        />
                    </Grid>

                    <FormGrupoImpostoItem adicionarImpostos={adicionarImpostos} />
                    <ListagemImpostos adicionarImpostos={adicionarImpostos} removerImposto={removerImposto} impostos={impostos} />
                    {primeiroAcesso ? '' : <Grid container>
                        <Grid item xs={6} className={classes.botaoRodape}>
                            <Button
                                variant="contained"
                                color="secondary"
                                type="button"
                                onClick={cancelar}
                                fullWidth
                            >
                                Cancelar
                                </Button>
                        </Grid>
                        <Grid item xs={6} className={classes.botaoRodape}>
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                onClick={salvar}
                                fullWidth
                            >
                                Salvar
                            </Button>
                        </Grid>
                    </Grid>}

                </form>
            </Paper>

        </Container>
    )
}

export default forwardRef(FormGrupoImposto);